import LeadImport from "./import"

export default LeadImport
